import EventEmitter from "./utils/EventEmitter";
import SelectSimple from "./form/SelectSimple";

export default class UserInterface extends EventEmitter {
    constructor() {
        super();

        this.userMenuButton = document.querySelector('.user-menu-button')
        this.asideUserMenu = document.querySelector('.aside-user-menu')

        if (this.userMenuButton) {
            this.userMenuButton.addEventListener('click', (e) => {
                this.asideUserMenu.classList.toggle('opened')
                this.userMenuButton.classList.toggle('opened')
            })

        }

        this.initSelects()
    }

    initFavoriteBtns() {
        this.favoriteBtns = Array.from(document.querySelectorAll('.favorite-btn'))

        this.favoriteBtns.forEach(btn => {
            btn.addEventListener('click', this.handleFavoriteBtnClick.bind(this))
        })
    }

    handleFavoriteBtnClick(e) {
        e.preventDefault();
        const btn = e.currentTarget;
        const vafLink = btn.querySelector('a');
        const url = vafLink.getAttribute('href');

        // Fetch url and update button
        fetch(url, {
            method: 'GET',
        })
            .then(response => {
                if (response.status === 200) {
                    this.removeFavoriteParent(btn)
                }
            })
    }

    removeFavoriteParent(btn) {
        // On cherche le premier parent qui a la classe favorite-item et on le retire du DOM
        let parent = btn.parentElement;
        while (!parent.classList.contains('favorite-item')) {
            parent = parent.parentElement;
        }
        parent.style.height = parent.offsetHeight + 'px';
        parent.classList.add('fade-out');
        setTimeout(() => {
            parent.style.height = '0';
        }, 450)
        setTimeout(() => {
            parent.remove()
        }, 2000)
    }

    initSelects() {
        this.selects = Array.from(document.querySelectorAll('.personal-information-form .js-form-type-select'))

        this.selects.forEach( (el) => {
            new SelectSimple(el)
        })
    }
}
